import React from 'react';
import { Play, Tv, Calendar } from 'lucide-react';
import { Card } from './ui/card';
import { mediaContent } from '../mockData';

const MediaSection = () => {
  const tvInterviews = [
    {
      id: 0,
      title: "Entrevista en Grupo Imagen",
      date: "11 de abril de 2026",
      type: "descript",
      embedUrl: "https://share.descript.com/embed/Gse8kQmoRS7"
    },
    {
      id: 1,
      title: "Entrevista en Grupo Imagen",
      date: "4 de marzo de 2026",
      type: "youtube",
      url: "https://youtu.be/uGlThd8RNfg?si=KZ_uHp1JThC0FQ5t&t=780",
      thumbnail: `https://img.youtube.com/vi/uGlThd8RNfg/maxresdefault.jpg`
    },
    {
      id: 2,
      title: "Entrevista en Grupo Imagen",
      date: "21 de febrero de 2026",
      type: "youtube",
      url: "https://youtu.be/JkXZdKqRKq4?si=-0_LgJRlpVsm8K-q&t=1740",
      thumbnail: `https://img.youtube.com/vi/JkXZdKqRKq4/maxresdefault.jpg`
    },
    {
      id: 3,
      title: "Entrevista en Grupo Imagen",
      date: "31 de enero de 2026",
      type: "youtube",
      url: "https://youtu.be/baW2pmsfZX0?t=2760",
      thumbnail: `https://img.youtube.com/vi/baW2pmsfZX0/maxresdefault.jpg`
    }
  ];

  return (
    <section id="medios" className="py-24 bg-gradient-to-br from-cream via-white to-lilac-light">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-golden/10 text-golden text-sm font-medium tracking-wider rounded-full mb-4">
            MEDIOS
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-charcoal mb-6">
            Conferencias & Entrevistas
          </h2>
          <p className="text-lg text-charcoal/70 max-w-3xl mx-auto leading-relaxed">
            Comparto mi conocimiento y experiencia en medios de comunicación, 
            conferencias y programas en vivo
          </p>
        </div>

        {/* TV Interviews Section - Grupo Imagen */}
        <div className="mb-20">
          <div className="flex items-center justify-center gap-4 mb-10">
            <div className="h-px bg-golden/30 flex-1 max-w-[100px]"></div>
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-full shadow-md border border-golden/20">
              <Tv className="text-red-600" size={24} />
              <h3 className="text-xl font-serif text-charcoal">
                Entrevistas en Televisión
              </h3>
              <img 
                src="https://customer-assets.emergentagent.com/job_e1a20952-b31c-4be9-b1e6-00ce412710a7/artifacts/o4qgd6ry_IMG_1700.png" 
                alt="Imagen Televisión" 
                className="h-10 ml-2"
              />
            </div>
            <div className="h-px bg-golden/30 flex-1 max-w-[100px]"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tvInterviews.map((interview) => (
              interview.type === 'descript' ? (
                <Card
                  key={interview.id}
                  className="overflow-hidden border-cream-dark hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                  data-testid={`tv-interview-${interview.id}`}
                >
                  <div className="relative overflow-hidden aspect-video">
                    <iframe
                      src={interview.embedUrl}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allowFullScreen
                      className="absolute inset-0 w-full h-full"
                      title={interview.title}
                    />
                  </div>
                  <div className="p-5">
                    <h4 className="text-lg font-serif text-charcoal mb-2">
                      {interview.title}
                    </h4>
                    <div className="flex items-center gap-2 text-sm text-charcoal/60">
                      <Calendar size={14} />
                      <span>{interview.date}</span>
                    </div>
                  </div>
                </Card>
              ) : (
                <a
                  key={interview.id}
                  href={interview.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block"
                  data-testid={`tv-interview-${interview.id}`}
                >
                  <Card className="overflow-hidden border-cream-dark hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                    <div className="relative overflow-hidden aspect-video">
                      <img
                        src={interview.thumbnail}
                        alt={interview.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-charcoal/40 group-hover:bg-charcoal/60 transition-colors duration-300 flex items-center justify-center">
                        <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          <Play className="text-white ml-1" size={24} fill="currentColor" />
                        </div>
                      </div>
                      <div className="absolute top-4 left-4">
                        <img 
                          src="https://customer-assets.emergentagent.com/job_e1a20952-b31c-4be9-b1e6-00ce412710a7/artifacts/o4qgd6ry_IMG_1700.png" 
                          alt="Imagen Televisión" 
                          className="h-8 bg-white/90 px-2 py-1 rounded"
                        />
                      </div>
                    </div>
                    
                    <div className="p-5">
                      <h4 className="text-lg font-serif text-charcoal mb-2 group-hover:text-golden transition-colors">
                        {interview.title}
                      </h4>
                      <div className="flex items-center gap-2 text-sm text-charcoal/60">
                        <Calendar size={14} />
                        <span>{interview.date}</span>
                      </div>
                    </div>
                  </Card>
                </a>
              )
            ))}
          </div>
        </div>

        {/* Conferences Section */}
        <div className="mb-16">
          <div className="flex items-center justify-center gap-4 mb-10">
            <div className="h-px bg-golden/30 flex-1 max-w-[100px]"></div>
            <h3 className="text-xl font-serif text-charcoal bg-white px-6 py-3 rounded-full shadow-md border border-golden/20">
              Conferencias
            </h3>
            <div className="h-px bg-golden/30 flex-1 max-w-[100px]"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {mediaContent.map((media) => (
              <Card 
                key={media.id} 
                className="group overflow-hidden border-cream-dark hover:shadow-xl transition-all duration-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={media.thumbnail}
                    alt={media.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-charcoal/40 group-hover:bg-charcoal/60 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Play className="text-golden ml-1" size={24} fill="currentColor" />
                    </div>
                  </div>
                  <div className="absolute top-4 right-4 bg-charcoal/80 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full">
                    {media.duration}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-serif text-charcoal mb-2 group-hover:text-golden transition-colors">
                    {media.title}
                  </h3>
                  <p className="text-sm text-charcoal/60">
                    {media.description}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Author Section */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative flex items-center justify-center">
            <div className="rounded-2xl overflow-visible shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_mujer-invierte/artifacts/fwdcswph_IMG_7545.JPG"
                alt="Kari Rojas"
                className="w-full max-w-md lg:max-w-lg h-auto rounded-2xl"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-golden/10 rounded-full blur-3xl -z-10"></div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-serif text-charcoal">
              Sobre Kari Rojas
            </h3>
            <p className="text-lg text-charcoal/80 leading-relaxed">
              Consultora, Terapeuta y Mentora Financiera con más de 10 años de experiencia 
              ayudando a mujeres a transformar su relación con el dinero.
            </p>
            <p className="text-charcoal/70 leading-relaxed">
              Autora del bestseller "Mujer, Construye tu Libertad Financiera", 
              Kari ha impactado la vida de más de 5,000 mujeres a través de sus cursos, 
              conferencias y programas de mentoría.
            </p>
            <p className="text-charcoal/70 leading-relaxed">
              Su enfoque combina estrategias financieras prácticas con trabajo emocional 
              y de mentalidad, ayudando a sus alumnas no solo a organizar sus finanzas, 
              sino a cambiar completamente su chip financiero.
            </p>
            
            <div className="flex flex-wrap gap-3 pt-4">
              <span className="px-4 py-2 bg-golden/10 text-golden text-sm rounded-full">
                Consultora Financiera
              </span>
              <span className="px-4 py-2 bg-golden/10 text-golden text-sm rounded-full">
                Terapeuta
              </span>
              <span className="px-4 py-2 bg-golden/10 text-golden text-sm rounded-full">
                Autora Bestseller
              </span>
              <span className="px-4 py-2 bg-golden/10 text-golden text-sm rounded-full">
                Inversionista
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaSection;
